//Componentes generales
import React, { useState } from "react";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faRotate } from "@fortawesome/free-solid-svg-icons";

const ProductRow = ({ producto, actualizarProductDBIndividual }) => {
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null); // null | 'ok' | 'error'

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const priceString = formatter.format(producto.price ? producto.price : 0);

  const handleActualizar = async () => {
    if (!actualizarProductDBIndividual || loading) return;
    setLoading(true);
    setFeedback(null);
    const resp = await actualizarProductDBIndividual(producto.tipPro, producto.artCod);
    setLoading(false);
    setFeedback(resp.status ? "ok" : "error");
    setTimeout(() => setFeedback(null), 2500);
  };

  return (
    <div className="container-p-list-item">
      <div className="container-p-list-item-horizontal">
        <div className="list-item-icon-p">
          <FontAwesomeIcon icon={faBox} />
        </div>
        <div className="label-title-products">
          Tipo Produto:{" "}
          <div className="label-products">{producto.tipPro}</div>
        </div>
        <div className="label-title-products">
          Código Articulo:{" "}
          <div className="label-products">{producto.artCod}</div>
        </div>
        <div className="label-title-products">
          Codigo Reducido:{" "}
          <div className="label-products">{producto.codRed}</div>
        </div>
        <div className="label-title-products">
          Unidad de Medida:{" "}
          <div className="label-products">{producto.uniMed}</div>
        </div>
        <div className="label-title-products">
          Último precio de compra:{" "}
          <div className="label-products">USD {priceString}</div>
        </div>
        <div className="label-title-products" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          Descripción:{" "}
          <div className="label-products">{producto.descrp}</div>
          {actualizarProductDBIndividual && (
            <button
              onClick={handleActualizar}
              disabled={loading}
              title="Actualizar este producto desde Softland"
              style={{
                marginLeft: "8px",
                padding: "5px 12px",
                fontSize: "0.85rem",
                fontWeight: "600",
                cursor: loading ? "not-allowed" : "pointer",
                border: "none",
                borderRadius: "5px",
                backgroundColor: feedback === "ok" ? "#28a745" : feedback === "error" ? "#dc3545" : "#495057",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                whiteSpace: "nowrap",
                opacity: loading ? 0.75 : 1,
                boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
              }}
            >
              <FontAwesomeIcon icon={faRotate} spin={loading} />
              {feedback === "ok" ? "Actualizado" : feedback === "error" ? "Error" : "Actualizar"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const RenderRow = ({ index, style, productos = [], filter, actualizarProductDBIndividual }) => {
  const lista = filter === ""
    ? productos
    : productos.filter(
        (p) =>
          p.descrp.toLowerCase().includes(filter.toLowerCase()) ||
          p.tipPro.toLowerCase().includes(filter.toLowerCase()) ||
          p.artCod.toLowerCase().includes(filter.toLowerCase()) ||
          p.codRed.toLowerCase().includes(filter.toLowerCase())
      );

  const producto = lista[index];
  if (!producto) return null;

  return (
    <div style={style} className="container-p-list">
      <li>
        <ProductRow
          producto={producto}
          actualizarProductDBIndividual={actualizarProductDBIndividual}
        />
      </li>
    </div>
  );
};

export default RenderRow;
